/* ==========================================================================
   FUEL PLAN controller.

   ONE job: when the customer picks a plan, mirror that plan's price into the
   big headline figure at the top of the buy box, so the page never shows
   INR 279 while the selected card says INR 251.

   THE CONTROL IS CORRECT WITHOUT THIS FILE. The radios are named
   `selling_plan`, which is the input Shopify's own cart already reads, so the
   choice reaches the order whether or not this parses. All that is lost if it
   fails is the headline number following the cards, and the cards are right.

   The formatted string is rendered by Liquid into a data attribute rather than
   formatted here. Formatting currency in JavaScript means reimplementing the
   shop's money_format, which is a setting, in a place that cannot read it.
   ========================================================================== */
(function () {
  'use strict';

  function apply(input) {
    var text = input.getAttribute('data-fuel-plan-money');
    if (!text) return;
    var nodes = document.querySelectorAll('[data-fuel-plan-headline]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = text;
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-fuel-plan-input]')) return;
    apply(input);
  });

  function init() {
    var checked = document.querySelector('[data-fuel-plan-input]:checked');
    if (checked) apply(checked);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
